/**
 * Extensions on `PlanDefinition.action` that say how a clinical-protocol action lands on the care
 * plan — which `CarePlanTopicService` method creates it and which task category the Task carries.
 * `protocol-*` so they read as definition-side, distinct from the `liza-task-category` input on the
 * resulting Task.
 */
export const PROTOCOL_EXTENSIONS = {
  /** `valueCode` ∈ `PROTOCOL_ITEM_KINDS`. */
  ITEM_KIND: 'https://liza.health/fhir/StructureDefinition/protocol-item-kind',
  /** `valueCode` ∈ `TASK_CATEGORY_CODES` (from `@liza/fhir-utils`). */
  TASK_CATEGORY: 'https://liza.health/fhir/StructureDefinition/protocol-task-category',
} as const;

/**
 * How a protocol action materializes on a patient's care plan. The first four are the care-plan item
 * kinds plus `survey` split out (a survey is a measurement whose Task also names a Questionnaire);
 * `suggestion` lands as a suggested action a clinician accepts, never as an item. Carried as
 * `valueCode` on the `protocol-item-kind` extension.
 */
export const PROTOCOL_ITEM_KINDS = ['measurement', 'survey', 'lifestyle', 'task', 'suggestion'] as const;
export type ProtocolItemKind = (typeof PROTOCOL_ITEM_KINDS)[number];
